interface FormToggleLabelProps {
  title: string;
  description?: string;
  className?: string;
}

export function FormToggleLabel({ title, description, className }: FormToggleLabelProps) {
  return (
    <div className={className}>
      <p className="fw-medium mb-0">{title}</p>
      {description && (
        <p className="small text-body-secondary mb-0">{description}</p>
      )}
    </div>
  );
}
